export default "__VITE_ASSET__CRsj2Yb8__"